import { FC, useEffect, useState } from "react";
import FaqItem from "components/FaqListing/FaqItem";
import Seo from "components/Seo/Seo";
import { getAllFaqSections } from "services/api";
import { IFaqSection } from "services/models";

const FaqPage: FC<any> = () => {
  const [sections, setSections] = useState<IFaqSection[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getAllFaqSections()
      .then((data) => {
        setSections(data);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to fetch FAQ sections");
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }
  // Sort sections by order
  sections.sort((a, b) => (a.order || 0) - (b.order || 0));

  const texts = sections.map((section) => ({
    title: section.title,
    questions: section.questions.map((q) => ({
      question: q.question,
      answer: q.answer,
    })),
    icon: "question-circle",
  }));

  return (
    <div
      className={`nc-FaqPolicy overflow-hidden relative`}
      data-nc-id="FaqPolicy"
    >
      <Seo
        name="F.A.Q | Orbito Travel"
        description="Get answers to your questions about accessible travel with Orbito Travel. Explore our frequently asked questions to learn more about our commitment to inclusivity and empowering travelers with reduced mobility. Start planning your accessible journey today!"
        title="F.A.Q | Orbito Travel"
        type="page"
      />
      <div className="container py-16 space-y-16 lg:space-y-28">
        <div className="w-screen max-w-full">
          <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100 mb-8">
            FAQ
          </h2>
          <div className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
            <FaqItem texts={texts} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqPage;
